import { GetterTree } from 'vuex';
import RootState from '@/store/RootState';
import Marker from '@/marker/Marker';
import Item from '@vuex-orm/core/lib/data/Item';
import MarkersState from '@/store/modules/markers/MarkersState';

const getters: GetterTree<MarkersState, RootState> = {
    activeMarker(state): Item<Marker> | null {
        if (state.activeMarkerId) {
            return Marker.query()
                .whereId(state.activeMarkerId)
                .withAllRecursive()
                .first();
        }

        return null;
    },

    activeMarkerId(state): string | null {
        return state.activeMarkerId;
    },

    activeMarkerCategory(state): string | null {
        return state.activeMarkerCategory;
    },
};

export default getters;
